import React, { Component } from "react";

import {
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Button,
  FormGroup,
  Label
} from "reactstrap";
import OutsideClickHandler from "react-outside-click-handler";
import StorageService from "../../services/Storage";
import { Roles } from "../../constants/constant.role";

class LocationWiseFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
      dropdownOpenYtd: false,
      regionData: [],
      monthOptions: [],
      areaData: [],
      yearOptions: [],
      isLoading: false,
      dealerRole: null,
      isAllIndia: true,
      ref: null,
      type: null,
      zoneName: null,
      znName: null,
      allZone: [],
      zoneData: {},
      Xerox: {}
    };
  }

  componentWillReceiveProps(props) {
    if (props.zone) {
      this.setState({
        allZone: props.zone
      });
    }
  }

  componentDidMount() {
    let Xerox = {
      ref: this.state.ref,
      type: this.state.type,
      isAllIndia: this.state.isAllIndia,
      zoneData: this.state.zoneData,
      zoneName: this.state.zoneName
    };
    this.setState({
      Xerox
    });
  }

  toggleClose = () => {
    this.setState({
      ref: this.state.Xerox.ref,
      type: this.state.Xerox.type,
      isAllIndia: this.state.Xerox.isAllIndia,
      zoneData: this.state.Xerox.zoneData,
      dropdownOpen: false,
      zoneName:
        this.state.Xerox &&
        this.state.Xerox.zoneData &&
        this.state.Xerox.zoneData.zone_name
    });

    if (this.state.Xerox.ref) {
      this.onZoneChange(this.state.Xerox);
    }
  };

  toggle = () => {
    let { dropdownOpen,
      // ref, type, isAllIndia, Xerox
    } = this.state;
    this.setState({
      dropdownOpen: !dropdownOpen
    });
  };

  onChangeIsAllIndia = () => {
    let { isAllIndia } = this.state;
    if (this.state.ref) {
      this.setState({
        isAllIndia: !isAllIndia,
        ref: null,
        type: null,
        zoneName: null,
        zoneData: {}
      });
    }
  };

  onZoneChange = zone => {
    if (zone.ref == "sz1") {
      this.setState({ znName: "South 1" });
    } else if (zone.ref == "sz2") {
      this.setState({ znName: "South 2" });
    } else if (zone.ref == "ez") {
      this.setState({ znName: "East" });
    } else if (zone.ref === "nz") {
      this.setState({ znName: "North" });
    } else if (zone.ref === "wz") {
      this.setState({ znName: "West" });
    }
    this.setState({
      ref: zone.ref,
      type: zone.type,
      isAllIndia: false,
      zoneData: zone.zoneData
    });
  };

  applyFilter = e => {
    e.preventDefault();
    let filter = {};
    if (this.state.isAllIndia) {
      filter = {
        type: null
      };
    } else {
      filter = {
        ref: this.state.ref ? this.state.ref : null,
        type: this.state.type ? this.state.type : null,
        zoneData: this.state.zoneData
      };
    }

    let Xerox = {
      ref: this.state.ref,
      type: this.state.type,
      isAllIndia: this.state.isAllIndia,
      zoneData: this.state.zoneData
    };

    this.setState({
      Xerox
    });
    
    if (this.state.ref == "sz1") {
      this.setState({ zoneName: "South 1" });
    } else if (this.state.ref == "sz2") {
      this.setState({ zoneName: "South 2" });
    } else if (this.state.ref == "ez") {
      this.setState({ zoneName: "East" });
    } else if (this.state.ref === "nz") {
      this.setState({ zoneName: "North" });
    } else if (this.state.ref === "wz") {
      this.setState({ zoneName: "West" });
    }

    this.props.getOffTakeSalesEntry(filter);
    this.props.getDirectIndirectData(filter);
    this.props.getFleetStatusCount(filter);
    this.toggle();
  };

  resetFilter = e => {
    e.preventDefault();
    this.setState(
      {
        ref: null,
        type: null,
        isAllIndia: true,
        zoneName: null,
        zoneData: {}
      },
      () => {
        this.props.getOffTakeSalesEntry("");
        this.props.getDirectIndirectData("");
        this.props.getFleetStatusCount("");
        let Xerox = {
          ref: this.state.ref,
          type: this.state.type,
          isAllIndia: this.state.isAllIndia,
          zoneData: null
        };

        this.setState({
          Xerox
        });
      }
    );
    this.toggle();
  };

  render() {
    let { isAllIndia } = this.state;
    return (
      <>
        <OutsideClickHandler onOutsideClick={this.toggleClose}>
          <Dropdown
            group
            isOpen={this.state.dropdownOpen}
            toggle={this.toggle}
            size="sm"
            style={{
              height:
                (StorageService.getUserDetail().type === Roles.ZONAL_FLEET_MANAGER_ROLE ||
                  StorageService.getUserDetail().type ===
                  Roles.HEAD_OFFICE_BAADSHAH_ROLE) &&
                "34px"
            }}
            className="dropdown-toggle-ho-all-india-filter-wrapper"
          >
            <DropdownToggle
              color="white"
              caret
              className="dropdown-toggle-ho-all-india-filter"
            >
              {isAllIndia ? " All India" : this.state.znName}
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-ho-all-india-filter">
              <div className="custom-dropdown-header">
                <span className="custom-dropdown-header-title cursor-pointer">
                  Filter
                </span>
                <img
                  className="cursor-pointer"
                  src="/images/close1.svg"
                  onClick={this.toggleClose}
                  alt="close1"
                />
              </div>
              <Row
                className="p-2"
                style={{ margin: "-5px", marginTop: "10px" }}
              >
                <Col xl="12" xs="12" sm="12" className="All-India-lbl">
                  <label className="custom-checkboax1--container">
                    <input
                      type="checkbox"
                      name="all_india"
                      checked={isAllIndia}
                      onChange={e => {
                        this.onChangeIsAllIndia(e);
                      }}
                    />
                    <span className="checkmark1" />
                  </label>
                  &nbsp;&nbsp;All India
                </Col>
                <Col xl="12" xs="12" ms="12" className="mt-4">
                  <FormGroup>
                    <Label className="All-India-lbl">Zone</Label>
                    <div className="d-flex flex-wrap">
                      {
                        (
                          this.state.allZone &&
                          this.state.allZone.map(item => (
                            <span>
                              <label class="radion-container lbl-common-12px">
                                {item && item.zone_name}
                                <input
                                  type="radio"
                                  name="dealerType"
                                  value={item.zone}
                                  checked={this.state.ref === item.zone}
                                  onChange={() => {
                                    this.onZoneChange({
                                      ref: item.zone,
                                      type: "zone",
                                      zoneData: item
                                    });
                                  }}
                                // checked={zone.value === 'nz'}
                                />
                                <span class="radio-checkmark"></span>
                              </label>
                              &nbsp;&nbsp;
                            </span>
                          )))
                      }
                    </div>
                  </FormGroup>
                </Col>
              </Row>
              <Row className="m-0" style={{ borderTop: "solid 0.5px #ced4da" }}>
                <Col
                  xl="6"
                  xs="6"
                  md="6"
                  className="text-align-right mt-3"
                  style={{ padding: "0px" }}
                >
                  <Button
                    className="mb-1 mr-1 btn-pill action-button profile-cancel-button"
                    color="dark"
                    onClick={e => {
                      this.resetFilter(e);
                    }}
                  >
                    Reset
                  </Button>
                </Col>
                <Col xl="6" xs="6" md="6" className="text-align-right mt-3">
                  <Button
                    className="mb-1 mr-1 btn-pill action-button profile-save-button"
                    color="warning"
                    onClick={e => {
                      this.applyFilter(e);
                    }}
                  >
                    Apply
                  </Button>
                </Col>
              </Row>
            </DropdownMenu>
          </Dropdown>
        </OutsideClickHandler>
      </>
    );
  }
}

export default LocationWiseFilter;
